export default __webpack_public_path__ + "static/media/ico_add_patient.a3e0e3dd.svg";